<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="tittle primary--text">{{ section }}</div>
      <v-spacer/>
      <div class="d-flex justify-end align-center mr-3">
        <v-btn
          class="mt-3 mt-md-0 ml-md-3 white--text"
          rounded
          color="primary"
          small
          depressed
          :href="exportRoute"
          target="_blank"
          >
          {{ $t('purchases.buttons.purchasesCSV') }}
        </v-btn>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        :items-per-page="25"
        sort-by="issuedAt"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:item.invoice.uuid="{ item }">
          {{ item.invoice.uuid }}
        </template>
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <div class="mr-3">
                    Filtros:
                  </div>
                  <div class="mr-3">
                    <v-menu
                      ref="datePicker"
                      v-model="datePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="range"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          hide-details
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="month"
                        type="month"
                        color="primary"
                        first-day-of-week="1"
                        no-title
                      >
                        <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                        <v-spacer/>
                        <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                        <v-btn :disabled="dates.length < 2" color="primary" @click="filterData">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </v-col>
               <v-col
                cols="12"
                md="3">
                <v-select
                  v-model="provider"
                  :items="providers"
                  item-text="name"
                  item-value="_id"
                  label="Proveedor"
                  dense
                  @change="filterData"
                  @click:clear="filterData"
                />
              </v-col>
              <v-col>
                <div class="d-flex justify-end align-center mr-1">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('accounting.labels.find')"
                    solo
                    hide-details
                    rounded
                    flat
                    dense
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.provider="{ item }">
          {{ !item.provider ? '-' : item.provider.name }}
        </template>
        <template v-slot:item.receiveDate="{ item }">
          <div>
            {{ item.statusChanges.createdAt | toDate() }}
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          {{ item.total | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
      </v-data-table>
    </v-flex>

  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'Accounting',
  data () {
    return {
      section: this.$i18n.t('accounting.section'),
      datePicker: false,
      month: new Date().toISOString(),
      order: {},
      uuid: '',
      search: '',
      providers: [],
      provider: '',
      table: {
        title: 'Cargando contabilidad',
        loading: true,
        headers: [
          { text: this.$i18n.t('purchases.headers.uuid'), value: 'uuid', sortable: false },
          { text: this.$i18n.t('purchases.headers.provider'), value: 'provider', sortable: false },
          { text: this.$i18n.t('purchases.headers.area'), value: 'area.name', sortable: false },
          { text: this.$i18n.t('purchases.headers.receiveDate'), value: 'receiveDate', sortable: false },
          { text: this.$i18n.t('purchases.headers.amount'), value: 'total', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          page: 1,
          itemsPerPage: 25,
          sortBy: ['createdAt'],
          sortDesc: [true],
          groupBy: [],
          groupDesc: [],
          mustSort: false,
          multiSort: false
        }
      }
    }
  },
  computed: {
    exportRoute () {
      const dates = this.dates.length === 2
        ? [this.$moment(this.dates[0]).startOf('day').toISOString(), this.$moment(this.dates[1]).endOf('day').toISOString()]
        : [null, null]
      let url = `${process.env.VUE_APP_API_URL}/v1/accounting/purchases/export`
      url += `?access_token=${this.$store.state.login.token}`
      url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      url += `&provider=${this.provider}&restaurant=${this.restaurant._id}`
      return url
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    dates () {
      const dates = []
      if (this.$moment(this.month).isValid()) {
        const start = this.$moment(this.month).startOf('month').format('YYYY-MM-DD')
        const end = this.$moment(this.month).endOf('month').format('YYYY-MM-DD')
        dates.push(start, end)
      }
      return dates
    }
  },
  watch: {
    'search': debounce(async function (val) {
      const params = {}

      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })

      params.restaurant = this.restaurant._id

      if (this.dates.length) {
        params['createdAt>'] = this.dates[0]
        params['createdAt<'] = `${this.dates[1]}T23:59:59`
      }
      if (this.provider) {
        params.provider = this.provider
      }
      if (val.length >= 2) {
        try {
          params.uuid = `/${val.replace(/ /g, '')}/gi`

          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load(params)
      }
    }, 300)
  },
  async mounted () {
    await this.load()
    await this.loadProviders()
  },
  methods: {
    async filterData () {
      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      const dates = {}
      if (this.dates.length) {
        dates['createdAt>'] = this.dates[0]
        dates['createdAt<'] = `${this.dates[1]}T23:59:59`
      }

      const params = {
        limit: this.table.options.itemsPerPage * this.table.options.page,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        restaurant: this.restaurant._id,
        ...dates
      }

      if (this.provider) {
        params.issuerTaxid = this.provider
      }

      await this.load(params)
      this.datePicker = false
    },
    updateTable: async function (data) {
      const dates = {}
      if (this.dates.length) {
        dates['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        dates['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }

      const params = {
        limit: data.itemsPerPage * data.page,
        skip: (data.itemsPerPage * (data.page - 1)),
        restaurant: this.restaurant._id,
        ...dates
      }

      if (this.provider) {
        params.issuerTaxid = this.provider
      }

      await this.load(params)
    },
    async resetDate () {
      this.dates = []
      await this.load()
      this.datePicker = false
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage * this.table.options.page,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        restaurant: this.restaurant._id
      }
      if (this.dates.length) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }

      this.table.loading = true
      try {
        const response = await this.$api.get('/v1/accounting/purchases', params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async loadProviders () {
      try {
        const providers = await this.$api.get('/v1/providers')
        providers.data.unshift({
          name: 'Todos',
          _id: ''
        })
        this.providers = providers.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    }
  }
}
</script>
